import React from 'react';
import classnames from 'classnames';
import Icon from 'shared/components/icon';
import 'stylesheets/components/shared-avatar.scss';

interface Props {
  userInfo: {
    firstName?: string;
    lastName?: string;
    image?: string | null;
    type?: string;
  };
  size?: 'small' | 'small-medium' | 'medium' | 'large' | 'medium-large';
  className?: string;
  id?: string;
}

const AvatarImage = ({userInfo: {image, firstName, lastName}, size, className = '', id}: Props) => {
  let fallback: React.ReactNode = <Icon iconType="user" testid="avatar-icon" />;

  if (firstName || lastName) {
    fallback = (firstName ? firstName[0] : '') + (lastName ? lastName[0] : '');
  }

  return (
    <span
      className={classnames('shared-avatar', size, className)}
      id={id}
      data-testid="avatar-image"
    >
      {image ? (
        <img
          src={image}
          aria-hidden="true"
          alt="avatar image"
          className="shared-avatar-image"
          data-testid="shared-avatar-image"
        />
      ) : (
        <span className="shared-avatar-initials" aria-hidden="true">
          {fallback}
        </span>
      )}
    </span>
  );
};

export default AvatarImage;
